export type ApplicationContext = {
    appVersion: string;
    environment: 'production' | 'staging' | 'development';
    requestId: string;
    pageId: string;
    smartlookKey: string | undefined;
    userId?: string;
    userName?: string;
    userEmail?: string;
    isExternalUser?: boolean;
    companyId?: string;
    companyName?: string;
    isPrimeMaintenanceSubscriber: boolean;
}

export function getApplicationContext(): ApplicationContext {
    const smgContext = JSON.parse(document.getElementById('SmgContext')?.innerText || '{}');

    return {
        appVersion: smgContext.appVersion || '0',
        environment: smgContext.environment || 'production',
        requestId: smgContext.requestId,
        pageId: smgContext.pageId,
        smartlookKey: smgContext.smartlookKey,
        userId: smgContext.userId,
        userName: smgContext.userName,
        userEmail: smgContext.userEmail,
        isExternalUser: smgContext.isExternalUser,
        companyId: smgContext.companyId,
        companyName: smgContext.companyName,
        isPrimeMaintenanceSubscriber: smgContext.isPrimeMaintenanceSubscriber
    };
}